import React from "react";

const First_Answer = () =>
{
    return(
        <>
        <div className="first_answer">
                <p>
                  The International Education Award have been instituted by TIME
                  CyberMedia Private<br/>
                  Limited a leading Brand Management and Business Consulting
                  organisation in India;
                  <br/>
                  operating from the National Capital New Delhi.
                </p>
              </div>
        </>
    )
}

export default First_Answer;